module.exports = __webpack_public_path__ + "hubspot-logo-71b1daa45709d22e688a2eb99c5cbc5e.webp";